import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

if ('serviceWorker' in navigator) {
	window.addEventListener('load', () => {
		navigator.serviceWorker.register('/service-worker.js').catch((error) => {
			console.error('Service-Worker-Registrierung fehlgeschlagen:', error);
		});
	});
}

// Wird eine installierte App (PWA) beendet und erneut geoeffnet, laedt der
// Browser die Seite oft nicht wirklich neu, sondern stellt einen eingefrorenen
// Zustand aus dem Back/Forward-Cache wieder her (event.persisted === true) -
// dabei laeuft unser Init-gesteuerter Start-Logik-Code (z.B. Startforum) nicht
// erneut. Ein erzwungener Reload in diesem Fall stellt sicher, dass die App
// immer frisch initialisiert wird, genau wie bei einem manuellen Reload.
window.addEventListener('pageshow', (event) => {
	if (event.persisted) {
		window.location.reload();
	}
});

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <React.StrictMode>
      <App key="webapp">
      </App>
  </React.StrictMode>
);

